import { Directive, Input, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

@Directive({
    selector: '[passwordAgainValidator][ngModel],[passwordAgainValidator][formControl]',
    providers: [{
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PasswordAgainValidator),
            multi: true
        }],
    standalone: true
})
export class PasswordAgainValidator implements Validator {
  @Input('password') public password: string;

  constructor() {}

  validate(c: AbstractControl): { [key: string]: any } {
    // Make sure a value is specified
    if (!c.value) {
      return {missingValue: true};
    }

    if (c.value !== this.password) {
      return {doesNotMatch: true};
    }

    return null;
  }
}
